import React from 'react';

export const renderActiveUsersWithColors = (recentActiveUsers, recentAnonymousCount, ActiveUserTag) => {
  const hasNamedUsers = recentActiveUsers && recentActiveUsers.length > 0;
  const hasAnonymousUsers = recentAnonymousCount > 0;

  if (!hasNamedUsers && !hasAnonymousUsers) {
    return null;
  }

  // Show max 3 named users with valid nicknames, with "and X more" if there are more
  const maxShow = 3;
  const validUsers = hasNamedUsers ? recentActiveUsers.filter(user => user.nickname && user.nickname.trim()) : [];
  const usersToShow = validUsers.slice(0, maxShow);
  const remainingNamedCount = Math.max(0, validUsers.length - maxShow);

  return (
    <>
      {usersToShow.map((user, index) => (
        <ActiveUserTag key={index} userColor={user.color}>
          {user.nickname}
        </ActiveUserTag>
      ))}
      {remainingNamedCount > 0 && (
        <span style={{ opacity: 0.7, fontSize: '0.75rem' }}>
          {remainingNamedCount} more
        </span>
      )}
      {hasAnonymousUsers && (
        <span style={{ opacity: 0.7, fontSize: '0.75rem' }}>
          {usersToShow.length > 0 || remainingNamedCount > 0 ? ' and ' : ''}{recentAnonymousCount} anon{recentAnonymousCount !== 1 ? 's' : ''}
        </span>
      )}
    </>
  );
};